import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { User } from '../../constants/constants';

@Component({
  selector: 'app-user-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>{{ getTitle() }}</h2>
    <mat-dialog-content>
      <p>Please confirm the following user details:</p>
      <div class="user-details">
        <p><strong>Username:</strong> {{data.user.username}}</p>
        <p><strong>Role:</strong> {{data.user.userrole}}</p>
        <p><strong>Church ID:</strong> {{data.user.church_id}}</p>
        <p><strong>Account Status:</strong>
          <span [class.locked]="data.user.account_locked" [class.unlocked]="!data.user.account_locked">
            {{data.user.account_locked ? 'Locked' : 'Unlocked'}}
          </span>
        </p>
        <p><strong>Password:</strong>
          <span [class.unchanged]="data.isEdit && !data.passwordChanged">
            {{getPasswordStatus()}}
          </span>
        </p>
      </div>
      <p>{{ getConfirmationMessage() }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button [color]="data.isDelete ? 'warn' : 'primary'" (click)="onYesClick()">
        {{ data.isDelete ? 'Delete' : 'Confirm' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .user-details {
      margin: 16px 0;
      padding: 16px;
      background-color: #f5f5f5;
      border-radius: 4px;
    }
    .user-details p {
      margin: 8px 0;
    }
    .unchanged {
      color: #666;
      font-style: italic;
    }
    .locked {
      color: #f44336;
      font-weight: bold;
    }
    .unlocked {
      color: #4caf50;
      font-weight: bold;
    }
  `]
})
export class UserConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UserConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      user: User;
      isEdit: boolean;
      isDelete?: boolean;
      passwordChanged?: boolean;
    }
  ) {}

  getTitle(): string {
    if (this.data.isDelete) {
      return 'Delete User Confirmation';
    }
    return `${this.data.isEdit ? 'Update' : 'Add'} User Confirmation`;
  }

  getPasswordStatus(): string {
    if (this.data.isDelete) {
      return '[hidden]';
    }
    if (this.data.isEdit && !this.data.passwordChanged) {
      return '[unchanged]';
    }
    return '[changed]';
  }

  getConfirmationMessage(): string {
    if (this.data.isDelete) {
      return `Are you sure you want to delete this user?`;
    }
    if (this.data.isEdit && this.data.user.account_locked !== undefined) {
      const action = this.data.user.account_locked ? 'lock' : 'unlock';
      return `Are you sure you want to ${action} and update this user?`;
    }
    return `Are you sure you want to ${this.data.isEdit ? 'update' : 'add'} this user?`;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
